<template>
  <div>
    <buttonlist
          @help="help"
      @opentable="opentable"
      @search="search"
      @reflash="reflash"
      @exps="exps"
      ref="SetBtn"
    ></buttonlist>

    <div style="margin-top: 2px">
      <el-button
        type="primary"
        size="mini"
        @click="showDialog"
        :disabled="!btn.transget"
        >{{$t('getapi[8837]')}}</el-button
      >
    </div>
    <wTable
            id="xpane-0"
            :data="dataSet"
            :loading="loading"
            queryData="ProPartShopViewInfo"
            :filter_thousandth="['pos_qty']"
            :header="tableHeader"
            :option="tableOption"
            @handleSelectionChange="handleSelectionChange"
            ref="singleTable"
    ></wTable>
    <!--<el-table
      :data="dataSet"
      v-loading="loading"
      :highlight-current-row="true"
      show-overflow-tooltip="true"
      border
      stripe
      size="mini"
      :height="tableHeight"
      @selection-change="handleSelectionChange"
      header-row-class-name="headerclass"
      style="width: 100%; margin-top:0px"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="SO_CODE"
        :label="$t('getapi[4285]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="Schedule_No"
        :label="$t('getapi[4209]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="part_code"
        :label="$t('getapi[112]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="part_version"
        :label="$t('getapi[149]')"
      ></el-table-column>
      <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="pos_qty"
        :label="$t('getapi[3101]')"
        align="right"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="shop_position_code"
        :label="$t('getapi[1842]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="shop_position_name"
        :label="$t('getapi[3471]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="routing_sequence_No"
        :label="$t('getapi[4286]')"
        align="right"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="workproc_name"
        :label="$t('getapi[574]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="batch_no"
        :label="$t('getapi[1763]')"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="sequence_no"
        :label="$t('getapi[1764]')"
        align="right"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="workcenter_name"
        label="下道工作中心名称"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="create_time"
        :label="$t('getapi[135]')"
      ></el-table-column>
    </el-table>-->
    <el-row class="page">
      <el-col :span="18">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-col>
      <el-col :span="6">
        <div
          style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;"
        >
          {{$t('getapi[7980]')}}:{{ DbTbNames }}
        </div>
      </el-col>
    </el-row>
    <serce
      :isVisible="isVisible"
      queryData="ProPartShopViewInfo"
      ref="ser"
      @getser="serclick"
    ></serce>
    <ctable :isVisible="false" :title="$t('getapi[6567]')" queryData="ProPartShopViewInfo" tabNo="0" ref="ctab"
            @getctab="sortclick"></ctable>
    <el-dialog v-dialogDrag
      :visible.sync="visReplacePart"
      :title="$t('getapi[8838]')"
      width="20%"
      :close-on-click-modal="false"
    >
      <div class="box" style="height: 120px;margin-top:5px">
        <div class="bbl">
          <span>{{$t('getapi[1628]')}}</span>
          <el-input
            type="number"
            autocomplete="off" title=""
            @mousewheel.native.prevent
            size="mini"
            style="width: 200px;"
            v-model="transobj.Qty"
          ></el-input>
        </div>
        <div class="bbl">
          <span>{{$t('getapi[2180]')}}</span>
          <el-select
            filterable
            popper-class="select-option"
            style="width: 200px;"
            v-model="transobj.cmbIssue_Dept"
            size="mini"
          >
            <el-option
              v-for="item in DeptList"
              :key="item.Code"
              :label="item.Name"
              :value="item.Name"
            ></el-option>
          </el-select>
        </div>

        <div style="text-align:center;margin-top:20px">
          <el-button type="primary" size="mini" @click="confirmtrans"
            >{{$t('getapi[1146]')}}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Common from "@/components/Common";
import Array from "@/components/Array";
import { Loading } from 'element-ui';
export default {
  name: "wxlz",
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
  data() {
    return {
      tableHeader: [],
      visReplacePart: false,
      dataSet: [], // 主表数据
      isVisible: false, // 查询列表是否显示
      queryData: [], // 查询数组
      userData: [], // 用户信息
      DbTbNames: "",
      pageIndex: 1, // 当前页
      pageSize: this.$http.getPageSize('wxlz'), // 当前页数据量
      SelectIndexs: 0, //当前页面
      total: 0, // 数据总量
      loading: false, // 主表加载状态
      selectData: [],
      DeptList: [], //领料部门数组
      transobj: {
        Qty: 0,
        cmbIssue_Dept: "",
        tempQty: 0,
        so_code: "",
        Flag: 1,
        Exclusively_ID: 0,
      },
      btn: {
        transget: false,
      },
        scrollTop:0,
    };
  },
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
  mounted: function() {
    let that = this;
      that.colsort();
    that.userData = sessionStorage.getItem("userData");
    that.PlanTypeArray = Array.methods.getPlanType();
    that.transobj.cmbIssue_Dept = that.DeptList[0].Name;
    that.authority();
  },
  created: function() {
    this.DeptList = Array.methods.getIssueDeptList();
  },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
  methods: {
      colsort() {
          let that = this;
          that.$loadviewfields.Fileds('ProPartShopViewInfo', 0, PFileds => {
              that.tableHeader = PFileds;
          });
      },
      sortclick(val) {
          if (val == 1) {
              this.colsort();
          }
      },
      // 修改表格顺序
      opentable() {
          this.$refs.ctab.clearInputs(true);
      },
      help(){
          this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1060]"),this.$t("getapi[13]"));
      },
    authority() {
      let that = this;
        if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
            that.$refs.SetBtn.SetOneBtnEnable('help',true);
        }
        that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
      //只读权
      if (that.$limits.ReadOnlyRightsView("plv2", 152, 1, that.total)) {
        if (that.total > 0) {
          that.$refs.SetBtn.SetButtonEnable("search,refresh,export");
        } else {
          that.$refs.SetBtn.SetButtonEnable("search,refresh");
        }
      }
      //操作权限-查询级别
      var limits = that.$limits.OperationAuthorityView(
        "plv2",
        152,
        1,
        that.total
      );
      // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
      switch (limits) {
        case -1:
          that.$refs.SetBtn.SetButtonEnable("search,refresh");
          break;
        case 1:
          that.$refs.SetBtn.SetButtonEnable("search,refresh,export");
          break;
        case -2:
          that.$refs.SetBtn.SetButtonEnable("search,refresh");
          break;
        case 2:
          that.$refs.SetBtn.SetButtonEnable("search,refresh,export");
          break;
        case -3:
          that.$refs.SetBtn.SetButtonEnable("search,refresh");
          break;
        case 3:
          that.$refs.SetBtn.SetButtonEnable("search,refresh,export");
          break;
        default:
          break;
      }
      that.btnauthority();
    },
    btnauthority() {
      let that = this;
      that.btn.endIssue = false;
      if (that.selectData.length > 0) {
        that.btn.endIssue = true;
        if(that.$limits.authority('plv4', 366, 1) != 0){
            that.btn.transget = true;
        } else {
            that.btn.transget = false
        }
      } else {
        that.btn.transget = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.$http.savePageSize('wxlz',val)
      this.getView();
      this.authority();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getView();
      this.authority();
    },
    // 查询
    search() {
      let that = this;
      that.isVisible = true;
      that.$refs.ser.clearInput(that.isVisible, "ProPartShopViewInfo");
    },
    //获取查询条件
    serclick(val) {
      this.queryData = val;
      this.pageIndex = 1;
      this.confirmGetView();
    },
    // 确认获取数据
    confirmGetView() {
      let that = this;
      that.pageIndex = 1
      that.isVisible = false;
      that.getView();
    },
    sign() {},
    // 数据一览
    getView() {
      let that = this;
      that.loading = true;
      let datac = [];
      for (let i = 0; i < that.queryData.length; i++) {
        datac.push({
          query_Condition: that.queryData[i].query_Condition,
          query_field_type: that.queryData[i].Query_Field_Type,
          query_field_name: that.queryData[i].Query_Field_Name,
          query_sort: that.queryData[i].query_sort,
          row_sign: that.queryData[i].row_sign,
        });
      }
      let token = JSON.parse(that.userData).token;
      let data = {
        PageIndex: that.pageIndex,
        PageSize: that.pageSize,
        SelectIndex: that.SelectIndexs,
        Param: datac,
      };
      that.$http.urlpost("/ISS/Stats/MoveConfirmList", data, function(res) {
        if (res.Success == 1) {
          that.dataSet = res.DataContent;
          that.total = res.Totals;
          that.loading = false;
          that.DbTbNames = res.DbTbNames;
          that.authority();
        }
      });
    },
    // 刷新
    reflash() {
      let that = this;
      that.getView();
    },
    // 导出
    exps() {
      /*let that = this;
      let datac = [];
      for (let i = 0; i < that.queryData.length; i++) {
        datac.push({
          query_Condition: that.queryData[i].query_Condition,
          query_field_type: that.queryData[i].Query_Field_Type,
          query_field_name: that.queryData[i].Query_Field_Name,
          query_sort: that.queryData[i].query_sort,
          row_sign: that.queryData[i].row_sign,
        });
      }
      let parm = {
        PageIndex: that.PageIndex,
        PageSize: that.PageSize,
        SelectIndex: that.SelectIndex,
        Ids: "",
        Param: datac,
      };
      that.$refs.SetBtn.SetOneBtnEnable("exps", false);
      that.$http.urlpost("/ISS/Stats/MoveConfirmExportToExecl", parm, function(
        res
      ) {
        that.$refs.SetBtn.SetOneBtnEnable("exps", true);
        if (res.Success == 1) {
          let hrefurl = Common.Url + res.DataContent.URL;
          window.open(hrefurl);
        }
      });*/
        let that = this;
        let datac = [];
        for (let i = 0; i < that.queryData.length; i++) {
            datac.push({
                query_Condition: that.queryData[i].query_Condition,
                query_field_type: that.queryData[i].Query_Field_Type,
                query_field_name: that.queryData[i].Query_Field_Name,
                query_sort: that.queryData[i].query_sort,
                row_sign: that.queryData[i].row_sign
            });
        }
        let parm = {
            query_sign: "ProPartShopViewInfo",
            fromname: that.$t('getapi[1060]'),
            SelectIndex: 0,
            MultyVer: that.$processdata.getLanguage(),
            Param: datac
        };
        that.$processdata.commonExport(parm)
    },
    handleSelectionChange(val) {
      let that = this;
      that.selectData = [];
      for (let i = 0; i < val.length; i++) {
        that.selectData.push(val[i]);
      }
      that.btnauthority();
    },
    showDialog() {
      let that = this;
       if (that.selectData.length > 1) {
        that.$message.warning(that.$t('getapi[8756]'));//"流转签收只能选择一条数据！"
        return;
      }
      that.visReplacePart = true;
      that.transobj.Qty = that.selectData[0].pos_qty;
    },
    confirmtrans() {
      let that = this;
      that.visReplacePart=true;
      if (that.selectData.length > 1) {
        that.$message.warning(that.$t('getapi[8756]'));//"请选择一条数据！"
        return;
      }
      // that.transobj.tempQty = that.selectData[0].pos_qty;
      // that.transobj.so_code= that.selectData[0].so_CODE;
      that.transobj.Exclusively_ID = that.selectData[0].ExclusivelY_ID;
      that.btn.transget = false
      let loadingInstance = Loading.service(Common.maskoption1);
      that.$http.urlpost("/Pro/MDIP/IssMoveCF", that.transobj, function(res) {
        if (res.Success == 1) {
            that.visReplacePart=false;
          that.$message.success(that.$t('getapi[321]'));//'设置成功！'
          that.getView();
          //reset
          // that.transobj = {
          //     Qty: 0,
          //     cmbIssue_Dept: that.DeptList[0].Name,
          //     tempQty: 0,
          //     so_code: '',
          //     Flag: -1,
          //     Exclusively_ID: 0
          //     }
        }
          loadingInstance.close()
      });
    },
    endIssue() {
      let that = this;
      let arr = [];
      for (let i = 0; i < that.selectData.length; i++) {
        arr = [
          ...arr,
          {
            so_code: that.selectData[i].so_code,
            part_id: that.selectData[i].part_id,
          },
        ];
      }
      let parm = {
        Lists: arr,
      };
      that.$http.urlpost("/Pro/SO/SOMaterilEndIssue", parm, function(res) {
        if (res.Success == 1) {
          that.$message.success(res.Msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
span.title {
  width: 100%;
  display: flex;
  height: 40px;
  line-height: 40px;
}

span.title .el-switch {
  display: inline-block;
  margin: 8px 30px;
}
.box {
  width: 100%;
  overflow-x: auto;
  .bbl {
    margin: 0px auto 10px;
    white-space: pre;
    span {
      margin-left: 10px;
      min-width: 70px;
      text-align: left;
      line-height: 20px;
      display: inline-block;
      margin-right: 0px;
    }
  }
}
table {
  border-collapse: separate;
  border-spacing: 0px 5px;
  td {
    padding-left: 3px;
    white-space: pre;
  }
}
</style>
